window.Lyceo = {};
window.Lyceo.state = window.Lyceo.state || {};

const baseHeaderTimeout = 200;
const headerBlurTimeout = 10;

export class HeaderBar {

  constructor() {
    this.previousTop = 0;
    this.currentTop = 0;
    this.scrollDelta = 10;
    this.scrollOffset = 150;

    this.headerTimeout = baseHeaderTimeout;
    this.showHeaderTimeout = null;
    this.nextHeaderTimeout = null;
    this.hideBlurTimeout = null;
    this.subMenu = $();

    this.$mainHeader = $('.main-header');
    this.$pageTabsAltWrapper = $('.page-tabs-alt-wrapper');
    this.$stickyHeaderBtn = $('.page-content__sticky-btn');
    this.$menuItem = $('.header-bar__main-menu-main-item');
    this.$megaMenuItem = $('.header-bar__main-menu-main-item--mega_menu');
    this.$mainContent = $('.main-content');

    $(window).on('scroll', () => this.check());
    $(window).on('resize', () => this.check());

    // check if we should resize the header
    this.check();

    this.$menuItem.on({
      mouseenter: e => this.mouseenter(e),
      mouseleave: () => this.mouseleave(),
    });
  }

  check() {
    this.currentTop = $(window).scrollTop();

    if (this.scollingUp() && this.isMobile() === false ) {
      this.toggle(true);
    } else if (this.scrollingDown() && this.isMobile() === false) {
      this.toggle(false);
    }

    this.previousTop = this.currentTop;
  }

  toggle(show) {
    let cssClass = show ? 'removeClass' : 'addClass';
    this.$mainHeader[ cssClass ]('main-header--compact');
    this.$pageTabsAltWrapper[ cssClass ]('page-tabs-alt-wrapper--compact');
    this.$stickyHeaderBtn[ cssClass ]('page-content__sticky-btn--compact');
    window.Lyceo.state['mainHeader'] = show ? '' : 'compact';
  }

  mouseenter(element) {
    clearTimeout(this.nextHeaderTimeout);
    clearTimeout(this.hideBlurTimeout);

    this.subMenu = $(element.target).siblings('.mega-menu, .header-bar__main-menu-dropdown-list').first();
    this.showHeaderTimeout = setTimeout(() => {
      if (this.subMenu.hasClass('mega-menu')) {
        this.subMenu.addClass('mega-menu--visible');
        this.$mainContent.addClass('blurred');
      } else {
        this.subMenu.addClass('header-bar__main-menu-dropdown-list--visible');
        this.$mainContent.removeClass('blurred');
      }
      this.showHeaderTimeout = null;
    }, this.headerTimeout);
  }

  mouseleave() {
    if (this.showHeaderTimeout === null) {
      this.headerTimeout = 0;
      this.nextHeaderTimeout = setTimeout(
        () => this.headerTimeout = baseHeaderTimeout,
        baseHeaderTimeout
      );
      this.hideBlurTimeout = setTimeout(
        () => this.$mainContent.removeClass('blurred'),
        headerBlurTimeout
      );
    } else {
      clearTimeout(this.showHeaderTimeout);
    }

    if (this.subMenu.hasClass('mega-menu')) {
      this.subMenu.removeClass('mega-menu--visible');
    } else {
      this.subMenu.removeClass('header-bar__main-menu-dropdown-list--visible');
    }
  }

  scollingUp() {
    return this.previousTop - this.currentTop > this.scrollDelta;
  }

  scrollingDown() {
    return (this.currentTop - this.previousTop > this.scrollDelta
            && this.currentTop > this.scrollOffset);
  }

  isMobile() {
    return $(window).width() < 767;
  }

}
